import React, { useEffect, useState } from 'react';
import { fetchDailyTotalTelemetry } from './api';
import robots from '../components/List_robots';
import RobotTelemetryTable from './120_RobotTelemetryTable';
import styled, { keyframes } from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`  
  padding: 0 20px 60px 20px;  
  background: #fafafa;  
`;

const zoomInOut = keyframes`  
  0% { transform: scale(1); }  
  50% { transform: scale(1.2); }  
  100% { transform: scale(1); }  
`;

const LoadingContainer = styled.div`  
  display: flex;  
  flex-direction: column;  
  justify-content: center;  
  align-items: center;  
  height: 100vh;  
  background: #fafafa;  
`;

const LoadingText = styled.div`  
  font-size: 2rem;  
  color: #FFFFFF;  
  font-weight: bold;  
  margin-bottom: 20px;  
`;

const LoadingImage = styled.img`  
  width: 100px;  
  height: 100px;  
  animation: ${zoomInOut} 2s infinite;  
  border-radius: 10px;  
`;

const Button = styled.button`  
  margin-top: 10px;  
  width: 100%;  
  padding: 10px;  
  font-size: 16px;  
  background-color: green;  
  color: white;  
  border: none;  
  border-radius: 5px;  
  cursor: pointer;  
  align-self: center;  
`;

function AllRobotsTelemetryPage() {
  const [telemetryData, setTelemetryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [batchIndex, setBatchIndex] = useState(0);
  const batchSize = 10; // 一度に取得するロボットの数  

  const navigate = useNavigate();
  const handleBack = () => {
    try {
      navigate(-1);
    } catch (error) {
      console.error('Error navigating back:', error);
    }
  };

  useEffect(() => {
    const fetchTelemetryBatch = async () => {
      try {
        const batch = robots.slice(batchIndex, batchIndex + batchSize);
        const batchData = await Promise.all(batch.map(async (robot) => {
          const data = await fetchDailyTotalTelemetry(robot.name, 7);
          return { name: robot.name, telemetry: data };
        }));
        setTelemetryData(prevData => [...prevData, ...batchData]);
        if (batchIndex + batchSize < robots.length) {
          setBatchIndex(prevIndex => prevIndex + batchSize);
        } else {
          setLoading(false);
        }
      } catch (e) {
        setError(e.message);
        setLoading(false);
      }
    };

    fetchTelemetryBatch();
  }, [batchIndex]);

  if (loading) {
    return (
      <LoadingContainer>
        <LoadingText>Loading...</LoadingText>
        <LoadingImage src="/robo_on.jpg" alt="Loading" />
      </LoadingContainer>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <Container>
      <h1>全てのロボの日付別収穫量</h1>
      <Button onClick={handleBack}>前の画面に戻る</Button>
      {telemetryData.map((robotData, index) => (
        <div key={index}>
          <h2>{robotData.name}</h2>
          <RobotTelemetryTable telemetryData={robotData.telemetry} />
        </div>
      ))}
      <Button onClick={handleBack}>前の画面に戻る</Button>
    </Container>
  );
}

export default AllRobotsTelemetryPage;  
